import { TileLayer } from '@deck.gl/geo-layers';

import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const esriArchiveYears = {
  esri2014:
    'https://wayback.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/10/{z}/{y}/{x}',
  esri2016:
    'https://wayback.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/2168/{z}/{y}/{x}',
  esri2018:
    'https://wayback.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/9486/{z}/{y}/{x}',
  esri2023:
    'https://wayback.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/25982/{z}/{y}/{x}',
};

type AerialYears = keyof typeof esriArchiveYears;
type YearUrls = typeof esriArchiveYears[AerialYears];

const esriArchiveLayer = (year: YearUrls = esriArchiveLayer.esri2014) =>
  new TileLayer({
    id: 'esri-archive-aerial-layer',
    data: [year],
    maxRequests: 17,
    pickable: true,
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export { esriArchiveLayer };
